import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="number-field"
export default class extends Controller {
  static targets = ['input', 'display']

  connect () {
    this.value = parseInt(this.inputTarget.value)
    this.min = parseInt(this.element.dataset.min)
    this.max = parseInt(this.element.dataset.max)
  }

  increment () {
    this.value = Math.min(this.value + 1, this.max)
    this.updateFields()
  }

  decrement () {
    this.value = Math.max(this.value - 1, this.min)
    this.updateFields()
  }

  updateFields () {
    this.inputTarget.value = this.value
    this.inputTarget.dispatchEvent(new Event('input'))
    this.displayTarget.textContent = this.value
  }
}
